var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBurger(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.78 16.5026H10.2513C9.56058 16.5026 9 15.942 9 15.2513C9 14.5606 9.56058 14 10.2513 14H37.78C38.4707 14 39.0313 14.5606 39.0313 15.2513C39.0313 15.942 38.4707 16.5026 37.78 16.5026ZM37.78 25.0112H10.2513C9.56058 25.0112 9 24.4507 9 23.7599C9 23.0692 9.56058 22.5086 10.2513 22.5086H37.78C38.4707 22.5086 39.0313 23.0692 39.0313 23.7599C39.0313 24.4507 38.4707 25.0112 37.78 25.0112ZM10.2513 33.5199H37.78C38.4707 33.5199 39.0313 32.9593 39.0313 32.2686C39.0313 31.5778 38.4707 31.0172 37.78 31.0172H10.2513C9.56058 31.0172 9 31.5778 9 32.2686C9 32.9593 9.56058 33.5199 10.2513 33.5199Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBurger);
export default __webpack_public_path__ + "static/media/burger.83c32d5001e4790b8984e858cb8db6f3.svg";
export { ForwardRef as ReactComponent };